import React, { ReactNode } from 'react';
import { CompetitionDateCallout } from '../CompetitionDateCallout/CompetitionDateCallout';
import { ContentBlock } from '@jbhi-fi/components/src/ContentBlock';
import { styles } from './CompetitionBlock.css';
import { CompetitionClosed } from '../CompetitionClosed/CompetitionClosed';
import { CardTag, CardTagProps } from '@jbhi-fi/components/src/Card';

export type CompetitionBlockProps = {
  tag?: CardTagProps;
  heading: string;
  intro: string;
  isLoading?: boolean;
  endDate: string;
  openingDate?: string;
  isOpen: boolean;
  winnerAnnouncementDate: string;
  content: ReactNode;
  enteredOn?: string;
  isCompetitionPerksOnly?: boolean;
  alreadyEnteredText?: string;
  isBallot?: boolean;
};

export const CompetitionBlock = ({
  isOpen,
  openingDate,
  tag,
  heading,
  intro,
  isLoading,
  endDate,
  winnerAnnouncementDate,
  content,
  enteredOn,
  isCompetitionPerksOnly,
  alreadyEnteredText,
  isBallot = false,
}: CompetitionBlockProps) => {
  return (
    <>
      {!isLoading && tag ? (
        <ContentBlock paddingTop={0}>
          <div className={styles.tag}>
            <CardTag {...tag} />
          </div>
        </ContentBlock>
      ) : null}
      <ContentBlock paddingTop={10.75}>
        <h1 className={styles.heading}>{heading}</h1>
      </ContentBlock>
      {!isCompetitionPerksOnly || !enteredOn ? (
        <ContentBlock paddingTop={10}>
          <p className={styles.intro}>{intro}</p>
        </ContentBlock>
      ) : null}
      {alreadyEnteredText && enteredOn ? (
        <ContentBlock paddingTop={5}>
          <div className={styles.alreadyEnteredText}>{alreadyEnteredText}</div>
        </ContentBlock>
      ) : null}
      <ContentBlock paddingTop={10} paddingBottom={7.5}>
        <CompetitionDateCallout
          endDate={endDate}
          winnerAnnouncementDate={winnerAnnouncementDate}
          enteredOn={enteredOn}
          isBallot={isBallot}
        />
      </ContentBlock>
      {isOpen ? (
        content
      ) : (
        <ContentBlock paddingTop={0} paddingBottom={0}>
          <CompetitionClosed openingDate={openingDate} isBallot={isBallot} />
        </ContentBlock>
      )}
    </>
  );
};
